export const en = [
  {
    name: 'Open Source Ecosystem',
    items: [
      {
        name: 'TiDB',
        url: 'https://en.pingcap.com/products/tidb',
      },
      {
        name: 'TiKV',
        url: 'https://github.com/tikv/tikv',
      },
      {
        name: 'TiSpark',
        url: 'https://github.com/pingcap/tispark',
      },
      {
        name: 'Chaos Mesh',
        url: 'https://github.com/pingcap/chaos-mesh',
      },
    ],
  },
  {
    name: 'Resources',
    items: [
      {
        name: 'Quick Start',
        url: '/tidb/stable/quick-start-with-tidb',
      },
      {
        name: 'Community',
        url: 'https://en.pingcap.com/community',
      },
      {
        name: 'Pricing',
        url: 'https://en.pingcap.com/tidb-cloud-pricing',
      },
    ],
  },
  {
    name: 'Use Cases',
    items: [
      {
        name: 'Internet',
        url: 'https://en.pingcap.com/customers/?industry=internet',
      },
      {
        name: 'Financial services',
        url: 'https://en.pingcap.com/customers/?industry=financial-services',
      },
      {
        name: 'Gaming',
        url: 'https://en.pingcap.com/customers/?industry=gaming',
      },
    ],
  },
  {
    name: 'Company',
    items: [
      {
        name: 'About',
        url: 'https://en.pingcap.com/about-us/',
      },
      {
        name: 'Careers',
        url: 'https://en.pingcap.com/careers',
      },
      {
        name: 'Legal',
        url: 'https://en.pingcap.com/legal',
      },
      {
        name: 'Blog',
        url: 'https://en.pingcap.com/blog',
      },
      {
        name: 'Contact Us',
        url: 'https://en.pingcap.com/contact-us/',
      },
    ],
  },
]

export const zh = [
  {
    name: '产品',
    items: [
      {
        name: 'TiDB',
        url: '/tidb/stable',
      },
      // {
      //   name: '生态工具',
      //   url: '/tools',
      // },
    ],
  },
  {
    name: '资源',
    items: [
      {
        name: '快速上手',
        url: '/tidb/stable/quick-start-with-tidb',
      },
      {
        name: '最佳实践',
        url: '/tidb/stable/tidb-best-practices',
      },
      {
        name: '常见问题解答',
        url: '/tidb/stable/tidb-faq',
      },
      {
        name: '版本发布',
        url: '/tidb/dev/release-notes',
      },
    ],
  },
  {
    name: '学习',
    items: [
      {
        name: '客户案例',
        url: 'https://pingcap.com/zh/case',
      },
      {
        name: 'PingCAP Education',
        url: 'https://learn.pingcap.com',
      },
      {
        name: 'TiDB in Action',
        url: 'https://book.tidb.io',
      },
    ],
  },
  {
    name: '支持',
    items: [
      {
        name: 'AskTUG',
        url: 'https://asktug.com',
      },
      {
        name: '联系我们',
        url: 'https://pingcap.com/zh/contact/',
      },
    ],
  },
  {
    name: '公司',
    items: [
      {
        name: '关于我们',
        url: 'https://pingcap.com/zh/about-us?tab=companyOverview',
      },
      {
        name: '招贤纳士',
        url: 'https://careers.pingcap.com',
      },
      {
        name: '新闻报道',
        url: 'https://pingcap.com/zh/about-us?tab=news',
      },
      {
        name: '博客',
        url: 'https://pingcap.com/zh/blog',
      },
    ],
  },
]

export const ja = [
  {
    name: 'エコシステム',
    items: [
      {
        name: 'TiDB',
        url: 'https://pingcap.co.jp/tidb-overview',
      },
      {
        name: 'TiKV',
        url: 'https://github.com/tikv/tikv',
      },
      {
        name: 'TiSpark',
        url: 'https://github.com/pingcap/tispark',
      },
      {
        name: 'Chaos Mesh',
        url: 'https://github.com/pingcap/chaos-mesh',
      },
    ],
  },
  {
    name: 'リソース',
    items: [
      {
        name: 'Quick Start',
        url: '/ja/tidb/stable/quick-start-with-tidb',
      },
      {
        name: 'イベント',
        url: 'https://pingcap.co.jp/event/',
      },
      {
        name: 'ニュース&ブログ',
        url: 'https://pingcap.co.jp/news-and-blogs/',
      },
      {
        name: '導入実績',
        url: 'https://pingcap.co.jp/usecase/',
      },
      {
        name: '価格',
        url: 'https://pingcap.co.jp/tidb-cloud/',
      },
    ],
  },
  {
    name: '会社関連',
    items: [
      {
        name: '会社概要',
        url: 'https://pingcap.co.jp/company/',
      },
      {
        name: '規約類',
        url: 'https://pingcap.com/legal',
      },
      {
        name: 'お問い合わせ',
        url: 'https://pingcap.co.jp/contact-us/',
      },
    ],
  },
]
